import * as React from "react";
import { useState } from "react";
import { Badge, Dialog, Box, Table, TableHead, TableRow, TableCell, TableBody, DialogContent } from "@material-ui/core";
import NotificationsIcon from "@material-ui/icons/Notifications";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../reducers/rootReducer";
import { ErrorI } from "../../interfaces/errors";
import { setNotificationButton, setNotificationLog, setFurnaceNotificationLog, setNotificationHistory, setApiResultStatus } from "../../slices/notificationLogSlice"
import {isTMTCameraDeviation, getEventDetails, getToken, isPingIDAuth, isThermalImageCoilSlice, getNotificationHeader, convertDateTimeBasedOnConfig, extractCoilNameFromSlice } from "../../utilities/helperFunctions";
import { Link } from "react-router-dom";
import { setCurrentFurnaceId } from "../../slices/scenarioSimulatorSlice";
import { setFurnaceId,setFurnaceOpMode } from "../../slices/furnaceSlice";
import { getCameraByCameraId, getFurnaceByFurnaceId } from "../../configuration";
import { setCameraNameForCameraStatus, setFurnaceNameForCameraStatus } from "../../slices/cameraStatusSlice";
import { setCurrentCamera, setCurrentCameraId, setSelectedTimestamp } from "../../slices/cameraSlice";
import "../../assets/styles/_notification_log.scss"
import store from "../..";
import { CLIENT_ID, OIDC_AUTHORITY_URL, REACT_APP_APIM_URL,TI_API_CALL_INTERVAL } from "../../utilities/GlobalConstants";
import { useAuth } from "react-oidc-context";
import { setCurrentCoil } from "../../slices/coilSlice";


export interface NotificationProps {}

/**
 * Notification component is used to give user information whenever something unusual happens during calculation on Feedstock
 */

const Notification: React.SFC<NotificationProps> = () => {
  const [showPopUp, setShowPopUp] = useState(false);
  const { errors }: { errors: ErrorI[] } = useSelector((state: RootState) => state.errorsState);
  const { accessibleFeatures } : any = useSelector((state: RootState) => state.features);
  let { notificationLog,showNotificationButton, filters, pagination } = useSelector((state: RootState) => { return state.notificationState});
  let { pageTitle }  = useSelector((state: RootState) => state.appState)

  const dispatch = useDispatch()
  const oidcAuth = useAuth(); 


  // react-oidc-context will always provide latest token even if current token expires and new token in renewed
  // local state "auth" will not update on oidcAuth token on first update, it will updated on page refresh, so no need to store it in local state
  // const [auth, setAuth] = useState(oidcAuth);
  // React.useEffect(() => {
  //   setAuth(oidcAuth);
  // }, [oidcAuth]);


  React.useEffect(() => {
    console.log(isTMTCameraDeviation(), accessibleFeatures,'isTMTCameraDeviation'); 
    if(isTMTCameraDeviation()){
      getNotificationLogData()
      getFurnaceNotificationLog()
      const interval = setInterval(() => {
        getNotificationLogData();
        getFurnaceNotificationLog();
        pageTitle = store.getState().appState.pageTitle;
        if (pageTitle === "Active Events") {
          getNotificationLog();
        }
    }, Number(TI_API_CALL_INTERVAL));

      console.log('notification interval called: ', interval);
      return () => {
        clearInterval(interval);
      };
    }
  }, [accessibleFeatures])


  const getFurnaceNotificationLog = async () => {
      const accessToken = isPingIDAuth() ? await getOidcToken() : await getToken(oidcAuth);
      fetch(`${REACT_APP_APIM_URL}/thermalimage/furnaceNotificationLog`, {
        method: "GET",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Origin": "*",
        }
      })
        .then((res) => res.json())
        .then(async (data) => {  
          dispatch(setFurnaceNotificationLog(data))
        })
        .catch((error) => {
          dispatch(setFurnaceNotificationLog({furnaceNotificationLog:[]}))   
          console.log(error)
        });
    }


  const getOidcToken = async () => {

    let data = sessionStorage.getItem(`oidc.user:${OIDC_AUTHORITY_URL}:${CLIENT_ID}`)
    return data ? JSON.parse(data).access_token : null;

    // if(!oidcAuth.user?.expired){
    //   console.log('existing token : ',await oidcAuth.user?.access_token,'check every time'); 
    //   return await oidcAuth.user?.access_token;
    // }else{
      // const refreshedToken = await oidcAuth.signinSilent()
      // console.log('refreshedToken : ',refreshedToken,'check every time');
      // return refreshedToken?.access_token;
    // }

  }


  const getNotificationLogData = async () => {
    // requried to get latest token for home api in case token is expired
    const accessToken = isPingIDAuth() ? await getOidcToken() : await getToken(oidcAuth);
    const filterModel = {
      filters: filters 
    }
    fetch(`${REACT_APP_APIM_URL}/thermalimage/getNotificationEvents/home`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
        "Access-Control-Allow-Origin": "*",
      }
    })
      .then((res) => res.json())
      .then(async (data) => {
        if(data && data?.rows?.length) {
          dispatch(setNotificationLog(data?.rows))
          dispatch(setNotificationButton(true))
        }
      })
      .catch((error) => {
        console.log(error)
      });
  }

  const getNotificationLog = async () => {
      console.log('getNotificationLog called')
      const queryParams = new URLSearchParams({
        page: pagination.page,
        pageSize: pagination.pageSize,
      });
      const filtersFromSession = JSON.parse(sessionStorage.getItem('notificationLogFilters')!)
      const sortingModelFromSession = JSON.parse(sessionStorage.getItem('notificationLogSortModel')!) 
      const notifiactionLogPayload = {
        filter: filtersFromSession ?? [],
        sort: sortingModelFromSession ?? []
      }
      const accessToken = await getToken(oidcAuth);
      const url = `${REACT_APP_APIM_URL}/thermalimage/getNotificationEvents/history?${queryParams.toString()}`;
      dispatch(setApiResultStatus(false))
      fetch(url,
        {
          method: "POST",
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + accessToken,
            "Access-Control-Allow-Origin": "*",
          },
          body: JSON.stringify(notifiactionLogPayload) 
        })
        .then((res) => res.json())
        .then(async (data) => {
          console.log("data",data);
          
          const responseObj = {
            rows: data.rows,
            totalRowCount: data.totalRowCount
          }
          dispatch(setNotificationHistory(responseObj))
          dispatch(setApiResultStatus(true))
        })
        .catch((error) => {
          dispatch(setNotificationHistory({rows: [], totalRowCount: 0}))
          dispatch(setApiResultStatus(true))
          console.log(error)
        });
    }
    
  const errorHeader = ["Date", "Source", "Message", "Error Code"]
  
  const showAllNotificationsOnClick = () => {
    setShowPopUp(false)
  }

  const onRedirect = (params) => {
    setShowPopUp(false)
    console.log(params,'check this params');
    let event_type = params['event_type'];
    let furnace_id = params['furnace_id'];
    let op_mode = params['operating_mode'];
    let cameraId = params['camera_id'];
    let selectedTimeStamp = event_type === 'TMT Deviation' ? params['start_of_event'] : params['timestamp'];
    let coilNumber = extractCoilNameFromSlice(params['sliceName']);
    
    let cameraName = getCameraByCameraId(cameraId);
    let furnaceName = getFurnaceByFurnaceId(parseInt(furnace_id));

    dispatch(setFurnaceId(furnace_id));
    dispatch(setCurrentFurnaceId(furnace_id));
    dispatch(setFurnaceOpMode(op_mode))

    if(event_type === 'TMT Deviation') {
      dispatch(setCurrentCameraId(cameraId));
      if(selectedTimeStamp) dispatch(setSelectedTimestamp(selectedTimeStamp));
      dispatch(setCurrentCamera(cameraName));
      dispatch(setCurrentCoil(coilNumber));
    } else {
      dispatch(setFurnaceNameForCameraStatus(furnaceName));
      dispatch(setCameraNameForCameraStatus(cameraName));
      dispatch(setCurrentCamera(cameraName));
    }    
        
  }

  const isTMTDeviation = (event_type) => {
    return event_type === 'TMT Deviation'
  }

  const notificationIcon = ((notificationLog.length === 0) || (notificationLog.length && !showNotificationButton))

  const dateConvert = (time) => {
    let dateTime = new Date(time);
    return dateTime.toLocaleString([],{dateStyle: 'medium', timeStyle: 'short'})
  }
  return (
    <React.Fragment>
      <Badge overlap="rectangular" badgeContent={isTMTCameraDeviation() ? notificationLog.length : errors.length} style={{ visibility: ((notificationIcon) && (errors.length === 0)) ? "hidden" : "inherit", marginRight: "20px" }} color="primary" invisible={((notificationLog.length === 0) && (errors.length === 0))} onClick={() => {
        dispatch(setNotificationButton(false))
        setShowPopUp(true)
        }}>
        <NotificationsIcon style={{ color: "red", visibility: (notificationLog.length === 0 && errors.length === 0) ? "hidden" : "inherit" }} />
      </Badge>
      <Dialog open={showPopUp} onClose={() => setShowPopUp(false)} maxWidth={false} scroll="paper">
        <DialogContent>
          <Box>
            <Table size="small" className="notification-log">
              <TableHead>
                <TableRow>
                  {errors && errors.length > 0 && errorHeader.map((header) => (
                    <TableCell key={header} className="bold">
                      {header}
                    </TableCell>
                  ))}
                  {isTMTCameraDeviation() && notificationLog && notificationLog.length > 0 && getNotificationHeader().map((header) => (
                    <TableCell key={header} className="bold">
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {errors && errors.length > 0 && errors.map((err) => (
                  <TableRow key={JSON.stringify(err)}>
                    <TableCell>{err.date}</TableCell>
                    <TableCell>{err.source}</TableCell>
                    <TableCell>{err.message}</TableCell>
                    <TableCell>{err.errorCode || "-"}</TableCell>
                  </TableRow>
                ))}
                {isTMTCameraDeviation() && notificationLog && notificationLog.length > 0 && notificationLog.slice(0, 10).map((log) => (                
                  <TableRow key={JSON.stringify(log)}>
                    <TableCell>
                      {isTMTDeviation(log['event_type']) ? 
                        <Link onClick={() => onRedirect(log)} to={'/thermalimage'}>{log['event_type']}</Link>    
                        :
                        <Link onClick={() => onRedirect(log)} to={'/camera-status/'}>{log['event_type']}</Link>               
                      }                 
                    </TableCell>
                    <TableCell>{log['rule_name']}</TableCell>
                    {/* <TableCell>{convertToLocaleDateTime(log['start_of_event'])}</TableCell> */}
                    <TableCell>{convertDateTimeBasedOnConfig((log['timestamp']))}</TableCell>
                    <TableCell>{getFurnaceByFurnaceId(log['furnace_id'])}</TableCell>
                    <TableCell>{log['camera_id']}</TableCell>
                    <TableCell>{log['operating_mode']}</TableCell>
                    <TableCell>{log['equipment_level']}</TableCell>
                    <TableCell className={log['rule_severity'] === 'High' ? 'high-severity' : 'medium-severity'}>{log['rule_severity']}</TableCell>  
                    <TableCell>{log['rule_category']}</TableCell>                 
                    <TableCell>{getEventDetails(log['rule_id'], getFurnaceByFurnaceId(log['furnace_id']), log['coilgroup_name_max'], log['coilgroup_name_min'], log['camera_id'],log['camera_temperature'],log['coilgroup_name'], log['camera_id_min'], log['camera_id_max'], log['firebox_name'], { sliceName: log['sliceName'], neighbourSliceName: log['neighbourSliceName'] })}</TableCell>              
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <div className="notification-buttons">
              {isTMTCameraDeviation() && notificationLog && notificationLog.length > 0 &&
                <Link onClick={showAllNotificationsOnClick} className="button is-primary" style={{ width: "100%", marginTop: "16px", marginRight: "10px" }} to={'/active-events-log'}> Show more </Link>
              }
              <button onClick={() => setShowPopUp(false)} className="button is-primary" style={{ width: "100%", marginTop: "16px" }}>
                Close
              </button>
            </div>
          </Box>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default Notification;
